import { NgxUiLoaderConfig, SPINNER } from 'ngx-ui-loader';

export const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    hasProgressBar: true,
    overlayColor  : 'rgba(255,255,255,.8)',
    bgsOpacity    : 0.6,
    bgsColor      : '#84BD00',
    fgsColor      : '#84BD00',
    bgsType       : SPINNER.doubleBounce,
    fgsType       : SPINNER.rectangleBouncePulseOut,
    pbColor       : '#84BD00',
    blur          : 5
};
